import React from 'react';
import { useEffect } from 'react';
import styles from './TerminosCondiciones.module.css';
import Footer from '../Home/Footer/Footer';

const TermsConditions = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
  return (
    <>
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>Términos y Condiciones</h1>
        
        <div className={styles.policyCard}>
          <div className={styles.dateInfo}>
            <p>
              <strong>Fecha de entrada en vigor:</strong> 21 de noviembre de 2024<br />
              <strong>Última actualización:</strong> 21 de noviembre de 2024
            </p>
          </div>
          <div className={styles.contentSection}>
            <p>
              Estos Términos y Condiciones (en adelante, "Términos") regulan el acceso y uso de los servicios proporcionados por <strong>RELATIVIDAD IA SOLUCIONES CON INTELIGENCIA ARTIFICIAL S.A.S.</strong> (en adelante, "Relatividad IA"), una empresa constituida bajo las leyes de la República del Ecuador, dedicada al desarrollo de software con inteligencia artificial personalizado para empresas. Al utilizar nuestros servicios, el cliente (en adelante, "Usuario") acepta los siguientes Términos:
            </p>

            <p>
              Los términos y condiciones describirán la relación contractual entre el USUARIO y RELATIVIDAD IA bajo las leyes de la Republica de Ecuador, con número de RUC 1793215455001. En ellos explicaremos los derechos y obligaciones que adquieren los USUARIOS, mediante el uso de nuestros servicios, por cualquier medio, y las reglas bajo las cuales se mantendrá la relación de manera directa. Todo lo anterior, al realizar clic y/o doble clic en los enlaces que el portal web tienen dispuestos para los efectos de recaudación y uso de los servicios de RELATIVIDAD IA.
            </p>

            <p>
              De la misma manera, al efectuar alguna de las actividades mencionadas anteriormente los clientes declaran que tienen capacidad jurídica y las facultades necesarias para obligarse de acuerdo con los presentes términos y condiciones. En caso de que quien utilice los servicios de RELATIVIDAD IA lo haga a nombre de una persona jurídica o de un tercero, dicha persona garantiza que esta plenamente facultada para obligar y/o representar a dicha persona. En caso de no estar facultado, el solicitante responderá personalmente por las obligaciones contraídas de acuerdo con los presentes términos y condiciones. 
            </p>

            <p>
              Sin perjuicio de lo anterior, y previa solicitud expresa y por escrito del USUARIO, RELATIVIDAD IA podrá enviar copia electrónica de los términos y condiciones que exponen en este instrumento. 
            </p>

            <div>
              <h2 className={styles.sectionTitle}>Sección 1. Definiciones</h2>
              <ul className={styles.definitionList}>
                <li><strong>Usuario:</strong> Persona natural o jurídica que adquiere los servicios de Relatividad IA.</li>
                <li><strong>Servicios:</strong> Desarrollo, capacitación, implementación y mantenimiento de software.</li>
                <li><strong>Plan:</strong> Modalidad de contratación que puede incluir servicios bajo membresía recurrente o de pago único.</li>
                <li><strong>Soporte Técnico:</strong> Servicio de atención para solucionar fallas o requerimientos relacionados con el uso del software.</li>
              </ul>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 2. Objeto</h2>
              <p>Relatividad IA proporciona servicios de desarrollo de software personalizado y acceso a soluciones tecnológicas de inteligencia artificial, capacitaciones bajo dos modalidades:</p>
              <ol className={styles.orderedList}>
                <li><strong>Pago Único:</strong> Servicios que otorgan acceso permanente a una solución o desarrollo específico, capacitación.</li>
                <li><strong>Membresía:</strong> Servicios, capacitaciones bajo un esquema de pago recurrente que incluyen actualizaciones, soporte técnico y mejoras continuas durante la vigencia del contrato.</li>
              </ol>
              <p>El Usuario contrata el uso de estos servicios de manera no exclusiva, no transferible y limitada a las condiciones acordadas en el contrato o plan adquirido.</p>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 3. Requisitos para acceder a los Servicios</h2>
              <ol className={styles.orderedList}>
                <li>Tener la capacidad jurídica para contratar según la ley del país donde resida el USUARIO.</li>
                <li>Contar con los recursos necesarios para pagar la contraprestación por los servicios.</li>
                <li>Todos los que RELATIVIDAD IA considere necesarios y sean previamente informados a los USUARIOS.</li>
              </ol>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 4. Obligaciones del Usuario</h2>
              <p>El Usuario se compromete a:</p>
              <ol className={styles.orderedList}>
                <li><strong>Proveer información veraz:</strong> Garantizar que toda la información entregada a Relatividad IA sea precisa y actualizada.</li>
                <li><strong>Cumplir con los pagos:</strong> Realizar los pagos en las fechas acordadas según el plan contratado.</li>
                <li><strong>Uso adecuado:</strong> No realizar actividades que comprometan la seguridad o funcionalidad del software, como ingeniería inversa o uso no autorizado.</li>
                <li><strong>Respetar los derechos de propiedad intelectual:</strong> Abstenerse de copiar, reproducir o distribuir el software sin autorización expresa de Relatividad IA.</li>
              </ol>
            </div>
            
            <div>
              <h2 className={styles.sectionTitle}>Sección 5. Obligaciones de RELATIVIDAD IA</h2>
              <p>Relatividad IA se compromete a:</p>
              <ol className={styles.orderedList}>
                <li>Proveer el servicio contratado en los términos y condiciones acordados.</li>
                <li>Brindar soporte técnico para atender fallas o consultas dentro de los horarios establecidos.</li>
                <li>Proteger los datos del Usuario conforme a la legislación ecuatoriana aplicable sobre protección de datos personales.</li>
              </ol>
            </div>
            
            <div>
              <h2 className={styles.sectionTitle}>Sección 6. Soporte Técnico</h2>
              <p>RELATIVIDAD IA pondrá a disposición del USUARIO, el canal de correo electrónico para brindar el soporte que permita responder a sus necesidades e inquietudes de la mejor manera posible; esto con el fin de dar respuesta bajo los siguientes puntos:</p>
              <ol className={styles.orderedList}>
                <li><strong>Disponibilidad:</strong> Relatividad IA ofrecerá soporte técnico en días hábiles, de lunes a viernes, en horario de 08:00 a 20:00 (hora de Ecuador).</li>
                <li><strong>Tiempo de Respuesta:</strong> Ver en los anexos los tiempos de respuesta y la clasificación de la prioridad.</li>
                <li><strong>Canales de comunicación:</strong>
                <ul className={styles.listSection}>
                        <li><strong>Correo electrónico:</strong> <a href="mailto:soporte@relatividadia.com" className={styles.contactLink}>soporte@relatividadia.com</a></li>
                    </ul>
                </li>
              </ol>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 7. Peticiones, quejas, reclamos y sugerencias</h2>
              <p>Las peticiones, quejas, reclamos y sugerencias se regirán por las siguientes disposiciones:</p>
              <ul className={styles.definitionList}>
                <li>Los USUARIOS pondrán interponerse a través del correo electrónico mencionado en la SECCIÓN 6.</li>
                <li>El USUARIO o un tercero en su representación, previa identificación, podrá presentar sus reclamaciones directas de forma gratuita, en los medios disponibles otorgados por RELATIVIDAD IA.</li>
                <li>RELATIVIDAD IA registrará e individualizará la reclamación asignándole un número a su reclamación, que será puesto en conocimiento de quien presentó la misma, a través de una copia o informándole el número de ésta.</li>
              </ul>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 8. Limitación de Responsabilidad</h2>
              <p>Relatividad IA no será responsable por:</p>
              <ol className={styles.orderedList}>
                <li>Daños indirectos, punitivos o incidentales derivadas del uso del software.</li>
                <li>Fallos ocasionados por mal uso, alteraciones no autorizadas o problemas ajenos a Relatividad IA.</li>
                <li>Fuerza mayor o eventos fuera del control razonable, como interrupciones de internet o ataques informáticos.</li>
                <li>Los USUARIOS proporcionen datos de identidad o información incorrectos, inexactos, no actualizados o falsos, y en particular, aunque de modo no exclusivo ni limitativo, por fados y perjuicios de cualquier naturaleza que se puedan deber a suplantación de personalidad de un tercero, efectuada por el USUARIO en cualquier clase de comunicación o transacción realizada a través de la plataforma.</li>
                <li>Por las infracciones de derechos de propiedad intelectual efectuadas por los USUARIOS, quienes se atribuyan la condición de derechos habientes, ya sea como titulares o licenciatarios de tales derechos, o quienes presuman contar con cualquier tipo de autorización para su uso.</li>
              </ol>
              <p>En cualquier caso, la responsabilidad de RELATIVIDAD IA está limitada al valor pagado por los servicios durante el periodo de 12 meses anterior al evento que dio lugar a la responsabilidad.</p>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 9. Tarifas</h2>
              <p>RELATIVIDAD IA enviará una factura de venta al USUARIO con los servicios prestados con anterioridad al inicio de la prestación del servicio. Una vez se realice el pago, el USUARIO tendrá acceso a los servicios y capacitaciones.</p>
              <p>RELATIVIDAD IA se reserva el derecho de suspender temporal o definitivamente el servicio cuando se incumplan los pagos, los platos y las condiciones de pago establecidos en estos términos y condiciones o en la factura.</p>
              <p>El USUARIO entiende y acepta que RELATIVIDAD IA se reserva el derecho a eliminar su información si el incumplimiento a las obligaciones y pagos persiste por más de noventa (90) días, sin perjuicio de las copias de seguridad que voluntariamente realice de la información del USUARIO, siempre respetando la normatividad vigente en cuanto a manejo de la información de Datos Personales.</p>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 10. Cancelación y Terminación</h2>
              <ol className={styles.orderedList}>
                <li><strong>Por parte del Usuario:</strong> El Usuario podrá cancelar su plan de membresía en cualquier momento, notificando con al menos 30 días de antelación. No se emitirán reembolsos por pagos ya realizados.</li>
                <li><strong>Por parte de Relatividad IA:</strong> La empresa se reserva el derecho de terminar el contrato en caso de incumplimientos graves de estos Términos por parte del Usuario o si no se ha realizado el pago de las Tarifas. RELATIVIDAD IA reanudará los Servicios máximo dentro de los (5) días hábiles siguientes a ello.</li>
              </ol>
            </div>
            
            <div>
              <h2 className={styles.sectionTitle}>Sección 11. Propiedad Intelectual</h2>
              <p>Todos los derechos sobre el software desarrollado, incluyendo código fuente, diseños, y cualquier contenido relacionado, son propiedad exclusiva de Relatividad IA. El Usuario no adquiere ningún derecho de propiedad sobre el software más allá del uso permitido por el contrato.</p>
            </div>
            
            <div>
              <h2 className={styles.sectionTitle}>Sección 12. Resolución de conflictos</h2>
              <p>Los clientes aceptan que para cualquier divergencia o discrepancia que se presente durante el uso del Software, Capacitación, el USUARIO y RELATIVIDAD IA dispondrán de un término de treinta (30) días calendario, contados a partir de la fecha del reclamo, para solucionar sus diferencias acudiendo a la negociación directa o a la conciliación.</p>
              <p>Si pasado este tiempo, no se puede llegar a ningún acuerdo, tanto el USUARIO como RELATIVIDAD IA, son libres de acudir a la justicia ordinaria.</p>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 13. Protección de Datos Personales</h2>
              <p>Relatividad IA tratará los datos personales del Usuario conforme a su Política de Privacidad y la Ley Orgánica de Protección de Datos Personales del Ecuador.</p>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Sección 14. Ley Aplicable y Jurisdicción</h2>
              <p>Estos Términos se regirán por las leyes de la República del Ecuador. En caso de disputas, las partes se someterán a los tribunales competentes de Quito, Pichincha.</p>
            </div>

            <div className={styles.acceptanceSection}>
              <h2 className={styles.sectionTitle}>Aceptación del Usuario</h2>
              <p>Al utilizar los servicios de Relatividad IA, el Usuario declara haber leído y aceptado estos Términos y Condiciones.</p>
            </div>

            <div>
              <h2 className={styles.sectionTitle}>Acuerdo de Niveles de Servicio</h2>
              <ol className={styles.orderedList}>
                <li>
                  <p>Los siguientes son los niveles de criticidad en virtud de los cuales se proveerán los servicios de Soporte al Cliente ante evento de fallas en los softwares adquiridos.</p>
                  <div className={styles.serviceTable}>
                    <table>
                      <thead>
                        <tr>
                          <th>PRIORIDAD</th>
                          <th>DESCRIPCIÓN</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className={styles.highPriority}>ALTA</td>
                          <td>La plataforma se encuentra operacional, pero seriamente afectado. Es importante resolver a la mayor brevedad.</td>
                        </tr>
                        <tr>
                          <td className={styles.mediumPriority}>MEDIA</td>
                          <td>Problema o pregunta, camino alterno aceptable. Es importante pero no necesariamente cubre una emergencia.</td>
                        </tr>
                        <tr>
                          <td className={styles.lowPriority}>BAJA</td>
                          <td>Requerimiento de información. Puede esperar a que se realicen las tareas de prioridad mayor.</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </li>
                <li>
                  <p>Los siguientes son los tiempos de respuesta ante el nivel de prioridad del evento</p>
                  <div className={styles.serviceTable}>
                    <table>
                      <thead>
                        <tr>
                          <th>PRIORIDAD / TIEMPO</th>
                          <th>ATENCIÓN*</th>
                          <th>REVISIÓN**</th>
                          <th>SOLUCIÓN***</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className={styles.highPriority}>ALTA</td>
                          <td>1 hora</td>
                          <td>60 minutos</td>
                          <td>2 horas</td>
                        </tr>
                        <tr>
                          <td className={styles.mediumPriority}>MEDIA</td>
                          <td>1 hora</td>
                          <td>90 minutos</td>
                          <td>48 horas</td>
                        </tr>
                        <tr>
                          <td className={styles.lowPriority}>BAJA</td>
                          <td>1 hora</td>
                          <td>120 minutos</td>
                          <td>60 horas</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className={styles.tableNotes}>
                      <p>(*) Atención: Tiempo que transcurre entre la solicitud o requerimiento y el acuse de recibo mediante saludo brindado por el Coordinador de Desarrollo.</p>
                      <p>(**) Revisión: Tiempo que transcurre entre el saludo del líder de desarrollo y la primera respuesta con respecto a la solicitud o requerimiento.</p>
                      <p>(***) Solución: Tiempo que transcurre entre el saludo del líder de desarrollo y el momento en el cual el caso queda resuelto.</p>
                    </div>
                  </div>
                </li>
                <li>
                  <p>Niveles de soporte y eventos</p>
                  <ul className={styles.definitionList}>
                    <li>Primer nivel: Área de Soporte / Evento de Prioridad: Alto, Medio, Bajo</li>
                    <li>Segundo nivel: Coordinador de Desarrollo / Evento de Prioridad: Desarrollo adicional.</li>
                  </ul>
                </li>
              </ol>
            </div>

          </div>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default TermsConditions;